import script from "./ApplyTdsVdsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplyTdsVdsModal.vue?vue&type=script&setup=true&lang=js"

import "./ApplyTdsVdsModal.vue?vue&type=style&index=0&id=60e92393&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60e92393"]])

export default __exports__